"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../../lib/utils.js";
var TooltipProvider = React.forwardRef(function (_a) {
    var _b = _a.delayDuration, delayDuration = _b === void 0 ? 0 : _b, props = __rest(_a, ["delayDuration"]);
    return (_jsx(TooltipPrimitive.Provider, __assign({ delayDuration: delayDuration }, props)));
});
TooltipProvider.displayName = TooltipPrimitive.Provider.displayName;
var Tooltip = React.forwardRef(function (_a) {
    var props = __rest(_a, []);
    return (_jsx(TooltipPrimitive.Root, __assign({}, props)));
});
Tooltip.displayName = TooltipPrimitive.Root.displayName;
var TooltipTrigger = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (_jsx(TooltipPrimitive.Trigger, __assign({ ref: ref, className: cn("", className) }, props)));
});
TooltipTrigger.displayName = TooltipPrimitive.Trigger.displayName;
var TooltipContent = React.forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.sideOffset, sideOffset = _b === void 0 ? 4 : _b, props = __rest(_a, ["className", "sideOffset"]);
    // Don't render if content is empty
    if (!props.children || (typeof props.children === 'string' && !props.children.trim())) {
        return null;
    }
    return (_jsx(TooltipPrimitive.Portal, { children: _jsxs(TooltipPrimitive.Content, __assign({ ref: ref, sideOffset: sideOffset, className: cn(
            // Use explicit CSS-variable colors so portaled tooltips never fall back to a white panel
            "border border-border/40 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit max-w-96 origin-(--radix-tooltip-content-transform-origin) rounded-lg px-3 py-2 text-[0.75rem] font-normal leading-[130%] text-wrap", className, 
            // Force lift-ui tooltip tokens after consumer className so MFE bg-* overrides cannot win twMerge
            "!bg-[hsl(var(--tooltip))] !text-[hsl(var(--tooltip-foreground))]") }, props, { children: [props.children, _jsx(TooltipPrimitive.Arrow, { className: cn("z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]", className, 
                    // Force arrow to match tooltip surface (ignore consumer bg overrides)
                    "!bg-[hsl(var(--tooltip))] !fill-[hsl(var(--tooltip))]") })] })) }));
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, };
